import { Box, Button } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const LinkButton = styled(Button)`
  &:hover {
    text-decoration: none;
    opacity: 60%;
  }
`
